import HeaderText from 'components/shared/header-text';

import { aboutData } from 'data/html/about';

import DescriptionEntry from 'components/shared/description-entry';

const AboutTab = () => (
  <div className="tab-view">
    <HeaderText
      fontSize="30px"
      fontWeight="bold"
      text="About HTML"
      margin="0 0 40px 0"
    />
    <div className="inner-tab-content">
      {aboutData?.items?.map((entry) => (
        <DescriptionEntry entry={entry} key={entry?.title} />
      ))}
    </div>
  </div>
);

export default AboutTab;
